/*global $*/
/*eslint no-undef: "error"*/

export default class ButtonAll {
	classButton = 'button-all--button'

	constructor () {
		let self = this

		$(`.${self.classButton}`).click(function () {
			let classItem = $(this).data('item')
			let objItem = $(`.${classItem}`)
			let classActive = $(this).data('active')

			if (objItem.length) {
				objItem.addClass(classActive)

				$(this).closest(`.button-center`).remove()
			}
		})
	}
}
